import React from 'react';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
import Img from '../../components/Img';
import Logo from 'assets/images/logo.png';
import i18n from '../../i18n';
import QRCode from 'qrcode.react';
import { FurnitureEditorContext } from '../../lib/constraintsChecker/FurnitureEditor';
import properties from '../../helpers/config';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import SchemaDimensionsContainer from '../SchemaDimensions';
import SchemaDimensions from '../SchemaDimensions/SchemaDimensions';
import { displayCabinetReference } from '../../helpers/tools';

export class CabinetFurniturePage extends React.Component<{
  t: any;
  cabinetOrFurniture: Cabinet | Furniture;
  pageBreakBefore?: boolean;
  context: FurnitureEditorContext;
}> {
  render() {
    const showShopInfos =
      properties.shopEmployee &&
      properties.shopName &&
      properties.shopPhone &&
      properties.shopContact;

    const { t, cabinetOrFurniture, pageBreakBefore, context } = this.props;
    return (
      <div className={pageBreakBefore ? 'page-break new-page' : 'new-page'}>
        <div className="flex items-center justify-center">
          <div className="flex items-center justify-center">
            <Img src={Logo} alt="Logo" className="header-page-logo" />
          </div>
        </div>
        <div className="page-section">
          <div className="page-title">
            {cabinetOrFurniture.getName(i18n.language)}
          </div>
          <div className="flex justify-between">
            <div>
              <div className="page-product-price-container">
                <span className="page-product-price">
                  {cabinetOrFurniture.displayPriceTaxInclude(
                    properties.vat,
                    properties.resellerRate,
                    properties.decimalSeparator,
                    properties.thousenSeparator,
                  )}
                  &nbsp;€
                </span>
                &nbsp;&nbsp;&nbsp;
                <i>{t('Tax Incl')}</i>
              </div>
              <div className="page-product-reference">
                {t('Reference')}&nbsp;&nbsp;&nbsp;
                <b>
                  {cabinetOrFurniture instanceof Cabinet
                    ? displayCabinetReference(cabinetOrFurniture.reference)
                    : cabinetOrFurniture.reference}
                </b>
              </div>
            </div>
            <div className="page-product-size">
              <div>
                {t('Height')}&nbsp;&nbsp;
                <b>{cabinetOrFurniture.height / 10}&nbsp;cm</b>
              </div>
              <div>
                {t('Width')}&nbsp;&nbsp;
                <b>{cabinetOrFurniture.width / 10}&nbsp;cm</b>
              </div>
              <div>
                {t('Depth')}&nbsp;&nbsp;
                <b>{cabinetOrFurniture.depth / 10}&nbsp;cm</b>
              </div>
            </div>
          </div>
        </div>
        {/* {t('Depth')} {cabinet.id} */}
        {cabinetOrFurniture.image && (
          <div className="page-section">
            <div className="flex items-center justify-center">
              <Img
                src={cabinetOrFurniture.image}
                alt="Image"
                className="page-main-image"
              />
              {cabinetOrFurniture instanceof Cabinet && (
                <div className="page-schema">
                  <SchemaDimensions item={cabinetOrFurniture} />
                </div>
              )}
            </div>
          </div>
        )}
        <div className="page-section">
          {cabinetOrFurniture.getDescription(i18n.language)}
        </div>
        <div className="page-section flex justify-around">
          {(process.env.NODE_ENV !== 'production' ||
            context !== FurnitureEditorContext.webShop) &&
            showShopInfos && (
              <div className="text-center flex flex-col justify-center items-center">
                <div className="flex font-bold">
                  {t('Your seller')} {properties.shopEmployee}
                </div>
                <div className="flex font-bold">
                  {t('Your shop')} {properties.shopName}
                </div>
                <div className="flex">{properties.shopContact}</div>
                <div className="flex">{properties.shopPhone}</div>
              </div>
            )}{' '}
          <div className="text-center flex flex-col justify-center items-center">
            <div className="flex page-qr">
              <QRCode
                value={`https://www.kewlox.com/q-${cabinetOrFurniture.reference}`}
                level="H"
                size={100}
                renderAs="svg"
              />
            </div>
            <div className="flex">
              <a
                href={`https://www.kewlox.com/k-${cabinetOrFurniture.reference}`}
                target="_blank"
              >
                {`kewlox.com/k-${cabinetOrFurniture.reference}`}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
